"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useOnAppEvent: ()=>useOnAppEvent,
    useOnceAppEvent: ()=>useOnceAppEvent,
    useEmitAppEvent: ()=>useEmitAppEvent
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _observer = require("./observer");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const useOnAppEvent = (event, listener, deps)=>{
    (0, _react.useEffect)(()=>{
        _observer.observer.on(event, listener);
        return ()=>_observer.observer.off(event, listener);
    }, deps);
};
const useOnceAppEvent = (event, listener, deps)=>{
    const [wasCalled, setWasCalled] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (wasCalled) {
            return;
        }
        const callback = (...args)=>{
            setWasCalled(true);
            listener(...args);
        };
        _observer.observer.once(event, callback);
        return ()=>_observer.observer.off(event, callback);
    }, deps);
};
const useEmitAppEvent = (event, data, deps = [
    data
])=>{
    (0, _react.useEffect)(()=>{
        _observer.observer.emit(event, data);
    }, deps);
};
